import React from "react";
import { Identifiable, Milestone as M } from "@planzone/dto";
import { MilestoneIcon } from "@common/milestoneIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Milestone({ element, height, width, progress }: Props) {
  return (
    <div className={styles.milestone}>
      <div className={styles.iconBox}>
        <MilestoneIcon
          className={styles.icon}
          style={{ width }}
          milestone={element as Identifiable<M>}
        />
      </div>
    </div>
  );
}

export { Milestone };
